/**
 * LO QUE «CUADRAR» NO PUEDE ARREGLAR, EN PALABRAS (MAC-02 y MAC-03, auditoría del 14-10).
 *
 * Si a una comida le falta un alimento de un macro (pollo, arroz y 10 g de aceite: faltan
 * 5 g de grasa y no queda nada con grasa que subir), «Cuadrar» no puede hacer nada, y la
 * pantalla mandaba a pulsarlo. QUIÉN DECIDE ESO ES EL SERVIDOR: el motor del botón cuadra la
 * comida y dice qué macros siguen faltando (`falta_fuente`, en `refit-diet` con `insistir`,
 * en `menu-apply` y en `cuadrar-comida`, todos con `core.cerrar_el_dia.falta_fuente`). Aquí
 * no se recalcula nada: solo se dice.
 */
import { NOMBRE_MACRO } from './exceso';

const enumerar = (xs) => (xs.length > 1 ? `${xs.slice(0, -1).join(', ')} y ${xs[xs.length - 1]}` : xs[0] || '');

/** «algo con grasa», «algo con hidratos y grasa». '' si no falta nada. */
export const algoCon = (faltaFuente) => {
    const nombres = (faltaFuente || []).map((m) => NOMBRE_MACRO[m]).filter(Boolean);
    return nombres.length ? `algo con ${enumerar(nombres)}` : '';
};

/**
 * El aviso de «Terminar el día» con las comidas fuera de su margen.
 *
 * `arreglables`: cuántas arregla «Cuadrar». Para ellas va la frase de Jesús (reunión del
 * 25-09), sin tocar. `conFalta`: [{ nombre, falta }] las que tienen un alimento de menos;
 * a esas se les dice qué añadir, que es lo que las resuelve.
 *
 * Devuelve { titulo, cuerpo, faltas }: `faltas` es una línea por comida con alimento de menos.
 */
export const avisoDeComidasACuadrar = ({ arreglables = 0, conFalta = [] } = {}) => {
    const faltas = conFalta
        .filter((c) => algoCon(c.falta))
        .map((c) => `${c.nombre} necesita ${algoCon(c.falta)}: añádelo.`);
    if (arreglables > 0) {
        return {
            titulo: `Para cuadrar el día, cuadra ${arreglables === 1 ? 'esta comida' : 'estas comidas'}`,
            cuerpo: `Entra en ${arreglables === 1 ? 'ella' : 'cada una'} y pulsa «Cuadrar».`,
            faltas,
        };
    }
    return {
        titulo: faltas.length === 1
            ? 'Para cuadrar el día, a esta comida le falta un alimento'
            : 'Para cuadrar el día, a estas comidas les falta un alimento',
        cuerpo: '',
        faltas,
    };
};

/**
 * La segunda línea del aviso «Los macros de este día no cuadran con los que tienes ahora».
 * La frase de Jesús (25-09) promete que las cantidades se ajustan de forma automática; si
 * TODAS las comidas que no cuadran (`comidas`: [{ nombre, falta }], la `falta` vacía en las
 * que «Cuadrar» sí arregla) tienen un alimento de menos, no se puede ajustar nada y se dice
 * qué añadir. `null` = va la frase de Jesús.
 */
export const lineaDelAvisoNoCuadran = (comidas = []) => {
    const lineas = comidas.filter((c) => algoCon(c.falta))
        .map((c) => `${c.nombre} necesita ${algoCon(c.falta)}`);
    if (!lineas.length || lineas.length !== comidas.length) return null;
    return `${enumerar(lineas)}: añádelo y podrás cuadrar el día.`;
};
